export default __webpack_public_path__ + "static/media/Group961.79144813.svg";